<div class="d-flex align-items-center" *ngIf="widgetLayers">
  <app-moment [value]="widgetLayers.dateFormat" [color]="color" (sendValue)="receiveValue($event)" class="flex-grow-1"></app-moment>
  <button (click)="dateFormatHelper.show()" class="z-depth-0 d-flex px-2 align-items-center mb-0 mr-0" size="sm" style="width: 30px; height: 31px;" type="button" mdbBtn color="light" mdbWavesEffect>
    <i class="fas fa-info fa-fw text-info"></i>
  </button>
</div>

<app-helper-date-format #dateFormatHelper></app-helper-date-format>